export interface BlockUIState {
    IsOpen: boolean,
}
export const BlockUIInitialState: BlockUIState = {
    IsOpen: false,
}

export const BlockUIActions = {
    BlockUI: `BLOCK_UI`,
    UnBlockUI: `UNBLOCK_UI`,
}

export const BlockUIActionCreators = {
    BlockUI: () => (dispatch) => {
        try {
            dispatch({
                type: BlockUIActions.BlockUI,
                payload: {
                    IsOpen: true,
                },
            });
        } catch (error) {
            dispatch({
                type: BlockUIActions.UnBlockUI,
                payload: {
                    IsOpen: false,
                },
            });
        }
    },
    UnBlockUI: () => (dispatch) => {
        try {
            dispatch({
                type: BlockUIActions.UnBlockUI,
                payload: {
                    IsOpen: false,
                },
            });

        } catch (error) {
            dispatch({
                type: BlockUIActions.UnBlockUI,
                payload: {
                    IsOpen: false,
                },
            });
        }
    }
}

export default BlockUIActionCreators;


export const BlockUIReducer = (state, { type, payload }) => {
    if (!state) {
        state = BlockUIInitialState;
    }
    if (type === BlockUIActions.BlockUI || type === BlockUIActions.UnBlockUI) {
        return {
            ...state,
            IsOpen: payload.IsOpen,
        };
    } else {
        return {
            ...state,
        };
    }
}
